module.exports = __webpack_public_path__ + "static/media/logout.41eb0b7f.svg";